// Layout.tsx
import { Outlet } from 'react-router-dom';
import { ThemeProvider, DefaultTheme } from 'styled-components';
import GlobalStyle from 'src/styles/styledcomponent/globalStyle';
import { useSyncSentryUser } from 'src/service/utils/sentry/syncUser';

interface LayoutProps {
  theme: DefaultTheme;
}

const Layout = ({ theme }: LayoutProps) => {
  useSyncSentryUser()

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Outlet />
    </ThemeProvider>
  );
}

export default Layout;